import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "capitalize",
  standalone: false,
})
export class CapitalizePipe implements PipeTransform {
  transform(value: any, words: boolean, split?: boolean) {
    if (value) {
      if (words) {
        return value.replace(/\b\w/g, (first) => first.toLocaleUpperCase());
      } else if (split) {
        return value.replace(/([a-z](?=[A-Z0-9]))/g, "$1 ");
      } else {
        return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
      }
    }
    return value;
  }
}
